import { FC } from "react";

const Centres: FC = () => {
    return (
        <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.70711 4.70711C8.31658 4.31658 7.68342 4.31658 7.29289 4.70711L2.29289 9.70711C2.10536 9.89464 2 10.149 2 10.4142V19C2 19.5523 2.44772 20 3 20H13C13.5523 20 14 19.5523 14 19V10.4142C14 10.149 13.8946 9.89464 13.7071 9.70711L8.70711 4.70711ZM12 18H9V16C9 15.4477 8.55228 15 8 15C7.44772 15 7 15.4477 7 16V18H4V11.2442C4 10.979 4.10536 10.7246 4.29289 10.5371L7.29289 7.53711C7.68342 7.14658 8.31658 7.14658 8.70711 7.53711L11.7071 10.5371C11.8946 10.7246 12 10.979 12 11.2442V18ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM17 20C17.5523 20 18 19.5523 18 19V8.76421C18 8.499 17.8946 8.24464 17.7071 8.05711L13.9429 4.29289C13.7554 4.10536 13.5008 4 13.2356 4C12.3447 4 11.8971 5.07714 12.5271 5.70711L15.7071 8.88711C15.8946 9.07464 16 9.329 16 9.59421V19C16 19.5523 16.4477 20 17 20ZM21 20C21.5523 20 22 19.5523 22 19V7.10421C22 6.839 21.8946 6.58464 21.7071 6.39711L19.6029 4.29289C19.4154 4.10536 19.1608 4 18.8956 4C18.0047 4 17.5571 5.07714 18.1871 5.70711L19.7071 7.22711C19.8946 7.41464 20 7.669 20 7.93421V19C20 19.5523 20.4477 20 21 20Z"
                fill="black"
              />
            </svg>
        </>
    )
}

export default Centres;